var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import Download01IconSvg from './download-01.icon.svg';
export const Download01Icon = (iconInstanceProps) => {
    return _jsx(Icon, { ...iconInstanceProps, SvgComponent: Download01IconSvg });
};
_react_refresh_temp_1 = Download01Icon;
$RefreshReg$(_react_refresh_temp_1, "Download01Icon");
